import { Image, Card, Content, CardBody } from '@wienenergiegithub/ui-next';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './Furnace.module.scss';

const Furnace = ({ image, className = null, text }) => (
  <Card className={className}>
    <CardBody className={styles.body}>
      <Image alt="" className={styles.image} src={image} />
      <Content noSpacing>{text}</Content>
    </CardBody>
  </Card>
);

Furnace.propTypes = {
  className: PropTypes.string,
  image: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export { Furnace };
